import ZFIcon from '../../../../component/ui-component/ZFIcon/ZFIcon';
import { RowColumnType, IDefaultColumnType, IMergedColumnType, IProgressBarColumnType } from './OrderListingTable.d';

const getDefaultColumn = (column: RowColumnType) => {
    return (column as IDefaultColumnType).value;
}

const getMergedColumn = (column: RowColumnType) => {
    return (
        <div className="merged-columns">
            {
                (column as IMergedColumnType).valueArray.map((valueArrayObj) => {
                    return (
                        <div key={valueArrayObj.key} className={valueArrayObj.classes ? valueArrayObj.classes.join(' ') : ''}>{valueArrayObj.value}</div>
                    )
                })
            }
        </div>
    )
}

const getProgressBarColumn = (column: RowColumnType) => {
    return (
        <>
        {
            <div style={{display: "flex"}}>
            {    (column as IProgressBarColumnType).valueArray.map((obj) => {
                    return (
                        <div key={obj.key} className="progress-column" style={{borderBottomColor: obj.legendColor}}>
                            <div className="progress-legend-dot" style={{backgroundColor: obj.legendColor}}></div>
                            <span>{obj.primaryValue}</span>
                            <span className="secondary-text">({obj.barPercentage}%)</span> 
                        </div>
                    )
                })
            }
            </div>
        }
        {
            <div style={{display: "flex"}}>
                {
                    (column as IProgressBarColumnType).valueArray.map((obj) => {
                        return (
                            <div key={obj.key} className="progress-percentage" style={{borderBottomColor: obj.legendColor, width: obj.barPercentage+'%'}}>
                            </div>
                        )
                    })
                }
            </div>
        }
        </>
    )
}

export const getDetailViewColumn = (showIcon: boolean, onRowClick: (orderShippableId) => void, orderShippableId?: string) => {
    return (
        <div className={"table-column detail-view-action"}>
        {
            (showIcon) && (
                <div onClick={() => onRowClick(orderShippableId)}>
                    {
                        <ZFIcon iconName="arrow-fw" iconClasses={['detail-view-icon']}/>
                    }
                </div>
            )
        }
       </div>
    )
}

export const getColumnTemplate = (column: RowColumnType) => {
    switch (column.columnType) {
        case 'MERGED': return getMergedColumn(column);
        case 'PROGRESS': return getProgressBarColumn(column);
        default: return getDefaultColumn(column);
    }
}